// extracted by mini-css-extract-plugin
module.exports = {"Menu":"pl_a pz_g","Menu__trigger":"pl_b pz_h","Menu__trigger--shadowed":"pl_c","Menu__menu":"pl_e pz_bh pz_g"};